import 'whatwg-fetch';
import Promise from 'es6-promise';

class HeaderEnrichmentService{
    static tryHeaderEnrichment(url){
        return fetch(url, {
            method: 'Get',
            headers: {},
            credentials: 'same-origin'
            });
        }
}

export default HeaderEnrichmentService;


/** WEBPACK FOOTER **
 ** ./src/services/headerEnrichmentService.js
 **/